<template>
  <div class="change-user-data">
    <div class="mdl-card mdl-shadow--2dp" v-if="state == 'done'">
      <div class="mdl-card__title mdl-color--primary">
        <h2 class="mdl-card__title-text">{{ i18n().done.title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand">
        {{ i18n().done.text }}
      </div>
    </div>
    <form class="mdl-card mdl-shadow--2dp" v-on:submit="change" v-if="state != 'done' && state!='loading'">
      <div class="mdl-card__title mdl-color--primary">
        <h2 class="mdl-card__title-text">{{ i18n().title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand">

        <div :class="{blurred: state=='working'}">
          <div class="serverError" v-if="error">{{ i18n().errors[error] || error }}</div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="firstName" v-model="editedUserData.firstName"
                   v-bind:required="required" ref="firstName">
            <label class="mdl-textfield__label" for="firstName">{{ i18n().firstName }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="lastName" v-model="editedUserData.lastName"
                   v-bind:required="required" ref="lastName">
            <label class="mdl-textfield__label" for="lastName">{{ i18n().lastName }}</label>
          </div>

          <PhoneInput class="phoneNumber field"
                      :value.sync="editedUserData.phoneNumber" :required="required" :invalid="phoneNumberInvalid"
                      :label="i18n().phoneNumber"></PhoneInput>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="companyName" v-model="editedUserData.companyName"
                   v-bind:required="required" ref="companyName">
            <label class="mdl-textfield__label" for="companyName">{{ i18n().companyName }}</label>
          </div>

          <CountryInput class="country field"
                      :value.sync="editedUserData.country" :required="required" :invalid="countryInvalid"
                      :label="i18n().country"></CountryInput>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="city" v-model="editedUserData.city"
                   v-bind:required="required" ref="city">
            <label class="mdl-textfield__label" for="city">{{ i18n().city }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="addressLine1" v-model="editedUserData.addressLine1"
                   v-bind:required="required" ref="addressLine1">
            <label class="mdl-textfield__label" for="addressLine1">{{ i18n().addressLine1 }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="addressLine2" v-model="editedUserData.addressLine2"
                   ref="addressLine2">
            <label class="mdl-textfield__label" for="addressLine2">{{ i18n().addressLine2 }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="postalCode" v-model="editedUserData.postalCode"
                   ref="postalCode">
            <label class="mdl-textfield__label" for="postalCode">{{ i18n().postalCode }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="taxNumber" v-model="editedUserData.taxNumber"
                   ref="taxNumber">
            <label class="mdl-textfield__label" for="taxNumber">{{ i18n().taxNumber }}</label>
          </div>


        </div>

        <div class="working" v-if="state == 'working'">
          <div class="mdl-spinner mdl-js-spinner is-active"></div>
        </div>

      </div>

      <div class="mdl-card__actions mdl-card--border" :class="{blurred: state=='working'}">
        <button :disabled="!dataEdited" type="submit" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
          {{ i18n().submit }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import api from "api"
  import PhoneInput from "../utils/PhoneInput.vue"
  import CountryInput from "../utils/CountryInput.vue"
  import countries from "../../config/countries"

  export default {
    name: 'change-user-data',
    components: { PhoneInput, CountryInput },
    data () {
      return {
        editedUserData: {},
        state: 'loading',
        required: true,
        phoneNumberInvalid: false,
        countryInvalid: false,
        error: null,
        allFields: [ 'firstName', 'lastName', 'phoneNumber', 'companyName', 'country', 'addressLine1', 'addressLine2',
          'postalCode', 'taxNumber' ],
        requiredFields: [ 'firstName', 'lastName', 'phoneNumber', 'companyName', 'country', 'city', 'addressLine1' ]
      }
    },
    reactive: {
      user: ['user','user']
    },
    computed: {
      userData() {
        if(!this.user) return null
        let data = JSON.parse(JSON.stringify(this.user.userData || {}))

        return data
      },
      dataEdited() {
        return JSON.stringify(this.editedUserData) != JSON.stringify(this.userData)
      }
    },
    watch: {
      userData() {
        if(!this.userData) return;
        this.editedUserData = JSON.parse(JSON.stringify(this.userData))
        let fields = this.allFields
        for(let field of fields) {
          if(!this.editedUserData[field]) this.editedUserData[field] = ''
        }
        if(this.editedUserData['phoneNumber']!='' && this.editedUserData['country'] =='') {
          let prefix = this.editedUserData['phoneNumber'].split(' ')[0]
          let found = countries.filter(c=>c.dial_code == prefix)[0]
          this.editedUserData['country'] = found ? found.code : ""
        }
        for(let field of fields) {
          if(this.editedUserData[field]!='') {
            let el = this.$refs[field]
            if(el) el = el.parentElement
            if(el) el.setAttribute('class', el.getAttribute('class').replace('is-invalid','')+' is-dirty')
          }
        }
        this.state='ready'
      }
    },
    methods: {
      i18n() { return i18n().user.changeUserData },
      change(e) {
        e.preventDefault()

        let anyEmpty = false
        for(let field of this.requiredFields) if(this.editedUserData[field].trim()=='') {
          let el = this.$refs[field][0]
          if(el) el = el.parentElement
          if(el) el.setAttribute('class', el.getAttribute('class')+' is-invalid')
          console.log("EMPTY FIELD", field)
          anyEmpty = true
        }
        if(anyEmpty) {
          return
        }

        let phoneNumber = this.editedUserData.phoneNumber
        let sep = phoneNumber.indexOf(' ')
        console.log("PN",phoneNumber, sep)
        if( sep == -1
          || phoneNumber.slice(0, sep).trim().length == 0
          || phoneNumber.slice(sep+1).trim().length < 3
          || !phoneNumber.match(/^[0-9 #+-]+$/)) {
          console.log("PN INVALID",
            phoneNumber.slice(0, sep).trim().length == 0,
            phoneNumber.slice(sep+1).trim().length < 3,
            !phoneNumber.match(/^[0-9 #+-]+$/)
          )
          this.phoneNumberInvalid = false
          this.phoneNumberInvalid = true
          this.required = true
          return;
        }

        this.state = "working"
        api.request(["user", "updateUserData"], this.editedUserData).then(result => {
          this.state = "done"
        }).catch(error => {
          this.error = error
          this.state = "ready"
        })
      }
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .change-user-data {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .change-user-data .mdl-card {
    width: 600px;
    max-width: 95%;
  }
  .mdl-card__supporting-text {
    width: 100%;
  }
  .field {
    max-width: 250px;
    margin-right: 1em;
  }

  .mdl-card__actions button {
    float: right;
  }

  .blurred {
    filter: blur(2px) grayscale(50%);
  }

  .working {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
  }
  .working div {
    margin: auto;
    height: 5em;
    width: 5em;
  }

  .serverError {
    color: darkred;
  }

</style>



// WEBPACK FOOTER //
// ChangeUserData.vue?215cdab6